<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Suppression de filtre</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">Vous êtes sur le point de supprimer le filtre '{{ data.name }}'.</p>
            <p class="text">Voulez vous continuer?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Valider</button>
    </mat-card-actions>
</mat-card>
